import { NgModule, ModuleWithProviders } from "@angular/core";

import { FormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { SharedModule } from "@app/shared/shared.module";
import { AiSettingsComponent } from "./pages/settings/ai-settings.component";
import { AiSettingsService } from "./services/ai-settings-data.service";

@NgModule({
    exports: [AiSettingsComponent],
    imports: [FormsModule, CommonModule, SharedModule, AiSettingsComponent],
})
export class AiModule {
    static forRoot(): ModuleWithProviders<AiModule> {
        return {
            ngModule: AiModule,
            providers: [AiSettingsService],
        };
    }
}
